import { render, staticRenderFns } from "./abandoned-deposit-list.vue?vue&type=template&id=54563870&scoped=true"
import script from "./abandoned-deposit-list.vue?vue&type=script&lang=js"
export * from "./abandoned-deposit-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54563870",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54563870')) {
      api.createRecord('54563870', component.options)
    } else {
      api.reload('54563870', component.options)
    }
    module.hot.accept("./abandoned-deposit-list.vue?vue&type=template&id=54563870&scoped=true", function () {
      api.rerender('54563870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/sale-management/abandoned/abandoned-deposit-list.vue"
export default component.exports